var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckedGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48639_18513)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 0.335938,
    width: 18.227,
    height: 18,
    rx: 3,
    fill: "#03B675"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2438 6.24596L8.37613 12.0405C8.23767 12.177 8.05001 12.2537 7.8544 12.2537C7.65872 12.2537 7.47113 12.177 7.3326 12.0405L4.54941 9.29182C4.36455 9.1075 4.29298 8.83994 4.36145 8.5894C4.42985 8.33896 4.62799 8.14329 4.88166 8.07567C5.13527 8.00812 5.4062 8.0788 5.59294 8.26136L7.70268 10.345C7.78645 10.4277 7.92232 10.4277 8.00608 10.345L13.1997 5.21605C13.3379 5.07824 13.5259 5.00051 13.7222 5C13.9186 4.9995 14.1071 5.07632 14.2459 5.2134C14.3848 5.35049 14.4625 5.53661 14.462 5.73057C14.4615 5.92445 14.3828 6.1102 14.2432 6.24658L14.2438 6.24596Z",
    fill: "#03B675"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48639_18513"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.335938,
    width: 18.227,
    height: 18,
    rx: 3,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedGreen);
export default __webpack_public_path__ + "static/media/checkedGreen.ba1d35ed2fb5361699378f0e617f445e.svg";
export { ForwardRef as ReactComponent };